import React from "react";
import { Select } from "antd";
const { Option } = Select;

export default function VendorSelect({ vendors, loading, onChange, value }) {
  return (
    <Select
      placeholder="Selecciona un vendedor"
      showSearch
      filterOption={(input, option) => {
        if (!option?.children || typeof option.children !== "string") {
          return false;
        }
        return option.children.toLowerCase().includes(input.toLowerCase());
      }}
      onChange={onChange}
      loading={loading}
      style={{ width: 300 }}
      value={value}
    >
      {vendors.map((vendor) => (
        <Option key={vendor.id} value={vendor.id}>
          {`${vendor.first_name} ${vendor.last_name}`}
        </Option>
      ))}
    </Select>
  );
} 